import { createReducer } from 'redux-create-reducer';
import callAPI from '../../../utils/callAPI';
import { BlockchainNameType, CryptoCurrencyType } from '../../../constant/currency';

// create order
export const REQUEST_CREATE_ORDER = 'REQUEST_CREATE_ORDER';
export const REQUEST_CREATE_ORDER_SUCCESS = 'REQUEST_CREATE_ORDER_SUCCESS';
export const REQUEST_CREATE_ORDER_FAILURE = 'REQUEST_CREATE_ORDER_FAILURE';
export const UPDATE_ORDER_DATA = 'UPDATE_ORDER_DATA';
export const ACTION_REQUEST_CREATE_ORDER = 'ACTION_REQUEST_CREATE_ORDER';

// create payment
export const ACTION_REQUEST_CREATE_PAYMENT = 'ACTION_REQUEST_CREATE_PAYMENT';
export const UPDATE_PAYMENT_DATA = 'UPDATE_PAYMENT_DATA';
export const REQUEST_CREATE_PAYMENT = 'REQUEST_CREATE_PAYMENT';
export const REQUEST_CREATE_PAYMENT_SUCCESS = 'REQUEST_CREATE_PAYMENT_SUCCESS';
export const REQUEST_CREATE_PAYMENT_FAILURE = 'REQUEST_CREATE_PAYMENT_FAILURE';

// confirm stripe
export const REQUEST_CONFIRM_STRIPE = 'REQUEST_CONFIRM_STRIPE';
export const REQUEST_CONFIRM_STRIPE_SUCCESS = 'REQUEST_CONFIRM_STRIPE_SUCCESS';
export const REQUEST_CONFIRM_STRIPE_FAILURE = 'REQUEST_CONFIRM_STRIPE_FAILURE';

// exchange point to token
export const UPDATE_EXCHANGE_BODY = 'UPDATE_EXCHANGE_BODY';
export const ACTION_REQUEST_EXCHANGE_POINT_TOKEN = 'ACTION_REQUEST_EXCHANGE_POINT_TOKEN';
export const REQUEST_EXCHANGE = 'REQUEST_EXCHANGE';
export const REQUEST_EXCHANGE_SUCCESS = 'REQUEST_EXCHANGE_SUCCESS';
export const REQUEST_EXCHANGE_FAILURE = 'REQUEST_EXCHANGE_FAILURE';

// buy point order
export const ACTION_REQUEST_BUY_POINT_ORDER = 'ACTION_REQUEST_BUY_POINT_ORDER';
export const UPDATE_BUY_POINT_ORDER_BODY = 'UPDATE_BUY_POINT_ORDER_BODY';
export const REQUEST_BUY_POINT_ORDER = 'REQUEST_BUY_POINT_ORDER';
export const REQUEST_BUY_POINT_ORDER_SUCCESS = 'REQUEST_BUY_POINT_ORDER_SUCCESS';
export const REQUEST_BUY_POINT_ORDER_FAILURE = 'REQUEST_BUY_POINT_ORDER_FAILURE';
export const UPDATE_BUY_POINT_ORDER_STATUS = 'UPDATE_BUY_POINT_ORDER_STATUS';

// confirm transaction
export const ACTION_REQUEST_CONFIRM_TRANSACTION = 'ACTION_REQUEST_CONFIRM_TRANSACTION';
export const REQUEST_CONFIRM_TRANSACTION = 'REQUEST_CONFIRM_TRANSACTION';
export const REQUEST_CONFIRM_TRANSACTION_SUCCESS = 'REQUEST_CONFIRM_TRANSACTION_SUCCESS';
export const REQUEST_CONFIRM_TRANSACTION_FAILURE = 'REQUEST_CONFIRM_TRANSACTION_FAILURE';

// get point quote
export const REQUEST_FETCH_POINT_QUOTE = 'REQUEST_FETCH_POINT_QUOTE';
export const REQUEST_FETCH_POINT_QUOTE_SUCCESS = 'REQUEST_FETCH_POINT_QUOTE_SUCCESS';
export const REQUEST_FETCH_POINT_QUOTE_FAILURE = 'REQUEST_FETCH_POINT_QUOTE_FAILURE';

// set state bulk buy
export const SET_IS_BULK = 'SET_IS_BULK';

// buy point by token
const defaultState = {
  // ================ order buy point =================
  createOrderBody: {
    points: '',
    isBulk: null
  },
  creatingOrder: false,
  createOrderSuccess: false,
  createOrderFailure: false,
  orderResponse: {},

  // ================ payment buy point =================
  createPaymentBody: {
    // paymentMethodId: '',
    orderId: '',
    provider: 'Stripe',
  },
  paymentResponse: {},
  creatingPayment: false,
  createPaymentSuccess: false,
  createPaymentFailure: false,

  // =================  stripe ======================
  confirmingStripe: false,
  confirmStripeSuccess: false,
  confirmStripeFailure: false,

  // ================ token amount =================
  exchangeBody: {
    pointAmount: 0,
    network: BlockchainNameType.solana,
    cryptoCurrency: CryptoCurrencyType.USDT,
    isBulk: null
  },

  exchangeResponse: {
    tokenAmount: 0,
  },

  exchangingPointToToken: false,
  exchangePointToTokenSuccess: false,
  exchangePointToTokenFailure: false,

  buyPointTokenOrderBody: {
    memo: '',
  },

  buyingPointTokenOrder: false,
  buyPointTokenOrderSuccess: false,
  buyPointTokenOrderFailure: false,
  buyPointTokenOrderResponse: {},

  confirmingTransaction: false,
  confirmTransactionSuccess: false,
  confirmTransactionFailure: false,

  fetchingPointQuote: false,
  fetchPointQuoteSuccess: false,
  fetchPointQuoteFailure: false,
  pointQuote: {},
  
};

const reducer = createReducer(defaultState, {
  // UPDATE ORDER BODY
  [UPDATE_ORDER_DATA]: (state, _action) => ({
    ...state,
    createOrderBody: _action.payload,
  }),

  [REQUEST_CREATE_ORDER]: (state, _action) => ({
    ...state,
    creatingOrder: true,
    createOrderSuccess: false,
    createOrderFailure: false,
    createPaymentBody: {
      // paymentMethodId: '',
      orderId: '',
      provider: 'Stripe',
    },
    paymentResponse: {},
  }),
  [REQUEST_CREATE_ORDER_SUCCESS]: (state, action) => ({
    ...state,
    creatingOrder: false,
    createOrderSuccess: true,
    createOrderFailure: false,
    orderResponse: action?.payload?.data,
  }),
  [REQUEST_CREATE_ORDER_FAILURE]: (state, _action) => ({
    ...state,
    creatingOrder: false,
    createOrderSuccess: false,
    createOrderFailure: true,
  }),

  // UPDATE PAYMENT BODY
  [UPDATE_PAYMENT_DATA]: (state, _action) => ({
    ...state,
    createPaymentBody: _action.payload,
  }),
  [REQUEST_CREATE_PAYMENT]: (state, _action) => ({
    ...state,
    creatingPayment: true,
    createPaymentSuccess: false,
    createPaymentFailure: false,
  }),
  [REQUEST_CREATE_PAYMENT_SUCCESS]: (state, action) => ({
    ...state,
    creatingPayment: false,
    createPaymentSuccess: true,
    createPaymentFailure: false,
    createPaymentBody: {
      paymentMethodId: '',
      orderId: '',
      provider: 'Stripe',
    },
    paymentResponse: action?.payload?.data,
  }),
  [REQUEST_CREATE_PAYMENT_FAILURE]: (state, _action) => ({
    ...state,
    creatingPayment: false,
    createPaymentSuccess: false,
    createPaymentFailure: true,
  }),

  // STRIPE
  [REQUEST_CONFIRM_STRIPE]: (state, _action) => ({
    ...state,
    createPaymentSuccess: false,
    confirmingStripe: true,
    confirmStripeSuccess: false,
    confirmStripeFailure: false,
  }),

  [REQUEST_CONFIRM_STRIPE_SUCCESS]: (state) => ({
    ...state,
    confirmingStripe: false,
    confirmStripeSuccess: true,
    confirmStripeFailure: false,
  }),

  [REQUEST_CONFIRM_STRIPE_FAILURE]: (state, _action) => ({
    ...state,
    confirmingStripe: false,
    confirmStripeSuccess: false,
    confirmStripeFailure: true,
  }),

  // =============== token =================

  // exchange

  [UPDATE_EXCHANGE_BODY]: (state, _action) => ({
    ...state,
    exchangeBody: _action.payload,
    tokenAmount: 0,
  }),

  [REQUEST_EXCHANGE]: (state, _action) => ({
    ...state,
    exchangingPointToToken: true,
    exchangePointToTokenSuccess: false,
    exchangePointToTokenFailure: false,
    confirmTransactionSuccess: false,
  }),

  [REQUEST_EXCHANGE_SUCCESS]: (state, action) => ({
    ...state,
    exchangeResponse: {
      tokenAmount: action?.payload?.data || 0,
    },
    exchangingPointToToken: false,
    exchangePointToTokenSuccess: true,
    exchangePointToTokenFailure: false,
  }),

  [REQUEST_EXCHANGE_FAILURE]: (state, _action) => ({
    ...state,
    exchangeResponse: {
      tokenAmount: 0,
    },
    exchangingPointToToken: false,
    exchangePointToTokenSuccess: false,
    exchangePointToTokenFailure: true,
  }),

  // buy point by token
  [UPDATE_BUY_POINT_ORDER_BODY]: (state, _action) => ({
    ...state,
    buyPointTokenOrderBody: _action.payload,
  }),

  [REQUEST_BUY_POINT_ORDER]: (state, _action) => ({
    ...state,
    buyingPointTokenOrder: true,
    buyPointTokenOrderSuccess: false,
    buyPointTokenOrderFailure: false,
  }),

  [REQUEST_BUY_POINT_ORDER_SUCCESS]: (state, action) => ({
    ...state,
    buyPointTokenOrderResponse: action?.payload?.data,
    buyingPointTokenOrder: false,
    buyPointTokenOrderSuccess: true,
    buyPointTokenOrderFailure: false,
    exchangeBody: {
      pointAmount: 0,
      network: BlockchainNameType.solana,
      cryptoCurrency: CryptoCurrencyType.USDT,
    },

    buyPointTokenOrderBody: {
      memo: '',
    },
  }),

  [REQUEST_BUY_POINT_ORDER_FAILURE]: (state, _action) => ({
    ...state,
    buyPointTokenOrderResponse: {},
    buyingPointTokenOrder: false,
    buyPointTokenOrderSuccess: false,
    buyPointTokenOrderFailure: true,
  }),

  [UPDATE_BUY_POINT_ORDER_STATUS]: (state, _action) => ({
    ...state,
    buyPointTokenOrderSuccess: _action.payload,
  }),

  // bulk buy point by token
  [UPDATE_BUY_POINT_ORDER_BODY]: (state, _action) => ({
    ...state,
    buyPointTokenOrderBody: _action.payload,
  }),

  [REQUEST_BUY_POINT_ORDER]: (state, _action) => ({
    ...state,
    buyingPointTokenOrder: true,
    buyPointTokenOrderSuccess: false,
    buyPointTokenOrderFailure: false,
  }),

  [REQUEST_BUY_POINT_ORDER_SUCCESS]: (state, action) => ({
    ...state,
    buyPointTokenOrderResponse: action?.payload?.data,
    buyingPointTokenOrder: false,
    buyPointTokenOrderSuccess: true,
    buyPointTokenOrderFailure: false,
    exchangeBody: {
      pointAmount: 0,
      network: BlockchainNameType.solana,
      cryptoCurrency: CryptoCurrencyType.USDT,
    },

    buyPointTokenOrderBody: {
      memo: '',
    },
  }),

  [REQUEST_BUY_POINT_ORDER_FAILURE]: (state, _action) => ({
    ...state,
    buyPointTokenOrderResponse: {},
    buyingPointTokenOrder: false,
    buyPointTokenOrderSuccess: false,
    buyPointTokenOrderFailure: true,
  }),

  [UPDATE_BUY_POINT_ORDER_STATUS]: (state, _action) => ({
    ...state,
    buyPointTokenOrderSuccess: _action.payload,
  }),

  // confirm transaction
  [REQUEST_CONFIRM_TRANSACTION]: (state, _action) => ({
    ...state,
    confirmingTransaction: true,
    confirmTransactionSuccess: false,
    confirmTransactionFailure: false,
  }),

  [REQUEST_CONFIRM_TRANSACTION_SUCCESS]: (state) => ({
    ...state,
    confirmingTransaction: false,
    confirmTransactionSuccess: true,
    confirmTransactionFailure: false,
  }),

  [REQUEST_CONFIRM_TRANSACTION_FAILURE]: (state, _action) => ({
    ...state,
    confirmingTransaction: false,
    confirmTransactionSuccess: false,
    confirmTransactionFailure: true,
  }),

  // get point quote
  [REQUEST_FETCH_POINT_QUOTE]: (state, _action) => ({
    ...state,
    fetchingPointQuote: true,
    fetchPointQuoteSuccess: false,
    fetchPointQuoteFailure: false,
  }),

  [REQUEST_FETCH_POINT_QUOTE_SUCCESS]: (state, action) => ({
    ...state,
    fetchingPointQuote: false,
    fetchPointQuoteSuccess: true,
    fetchPointQuoteFailure: false,
    pointQuote: action?.payload?.data,
  }),

  [REQUEST_FETCH_POINT_QUOTE_FAILURE]: (state, _action) => ({
    ...state,
    fetchingPointQuote: false,
    fetchPointQuoteSuccess: false,
    fetchPointQuoteFailure: true,
  }),

  [SET_IS_BULK]: (state, _action) => ({
    ...state,
    createOrderBody:{
      ...state.createOrderBody,
      isBulk: _action.payload
    }  ,
    exchangeBody:{
      ...state.exchangeBody,
      isBulk: _action.payload
    }  
  }),
});

export default reducer;
export const namespace = 'buyPointForHunt';

export const actionCreateOrder = () => ({
  type: ACTION_REQUEST_CREATE_ORDER,
});

export const getPointQuoteAPI = () => async (dispatch, getState) => {
  return await callAPI({
    method: 'get',
    apiPath: 'orders/point-quote',
    actionTypes: [
      REQUEST_FETCH_POINT_QUOTE,
      REQUEST_FETCH_POINT_QUOTE_SUCCESS,
      REQUEST_FETCH_POINT_QUOTE_FAILURE,
    ],
    variables: {},
    dispatch,
    getState,
  });
};

export const createOrderAPI = (data) => async (dispatch, getState) => {
  return await callAPI({
    method: 'post',
    apiPath: 'orders/buy-point/card',
    actionTypes: [REQUEST_CREATE_ORDER, REQUEST_CREATE_ORDER_SUCCESS, REQUEST_CREATE_ORDER_FAILURE],
    variables: {
      ...data,
    },
    dispatch,
    getState,
  });
};

export const actionCreatePayment = () => ({
  type: ACTION_REQUEST_CREATE_PAYMENT,
});

export const createPaymentAPI = (data) => async (dispatch, getState) => {
  return await callAPI({
    method: 'post',
    apiPath: 'payments/create',
    actionTypes: [
      REQUEST_CREATE_PAYMENT,
      REQUEST_CREATE_PAYMENT_SUCCESS,
      REQUEST_CREATE_PAYMENT_FAILURE,
    ],
    variables: {
      ...data,
    },
    dispatch,
    getState,
  });
};

// exchange point to token
export const actionExchangePointToToken = (payload) => ({
  type: ACTION_REQUEST_EXCHANGE_POINT_TOKEN,
  payload,
});

export const exchangePointToTokenAPI = (data) => async (dispatch, getState) => {
  return await callAPI({
    method: 'get',
    apiPath: 'exchange/buy-points/estimate-tokens',
    actionTypes: [REQUEST_EXCHANGE, REQUEST_EXCHANGE_SUCCESS, REQUEST_EXCHANGE_FAILURE],
    variables: {
      ...data,
    },
    dispatch,
    getState,
  });
};

// buy point to token order
export const actionBuyPointToTokenOrder = (payload) => ({
  type: ACTION_REQUEST_BUY_POINT_ORDER,
  payload,
});

export const buyPointToTokenOrderAPI = (data) => async (dispatch, getState) => {
  return await callAPI({
    method: 'post',
    apiPath: 'orders/buy-point/crypto',
    actionTypes: [
      REQUEST_BUY_POINT_ORDER,
      REQUEST_BUY_POINT_ORDER_SUCCESS,
      REQUEST_BUY_POINT_ORDER_FAILURE,
    ],
    variables: {
      ...data,
    },
    dispatch,
    getState,
  });
};

export const actionConfirmTransaction = (payload) => ({
  type: ACTION_REQUEST_CONFIRM_TRANSACTION,
  payload,
});

export const confirmTransactionAPI = (data) => async (dispatch, getState) => {
  return await callAPI({
    method: 'post',
    apiPath: 'transactions/crypto/buy-points/confirm',
    actionTypes: [
      REQUEST_CONFIRM_TRANSACTION,
      REQUEST_CONFIRM_TRANSACTION_SUCCESS,
      REQUEST_CONFIRM_TRANSACTION_FAILURE,
    ],
    variables: {
      ...data,
    },
    dispatch,
    getState,
  });
};
